import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";
import { fromPairs as _fromPairs, flattenDeep, uniq, without } from 'lodash';


const initialState = {
    list: {
        package: { label: '', value: '', type: '', haveRevisionLabels: false },
        packageOptions: [],
        isLoading: false,
        spools: [],
        error: "",
        cutListId: '',
        showGeneraterCode: false,
        spoolDetails: [],
        showSpoolDetails: false,
        cutting: true,
        defaultPackages: [],
        currentPage: 1,
        packageList: [],
        pageCount: 1,
        spoolComponents: [],
        cutListSizes: [],
        cutListSize: { label: 'All', value: '' },
        cutListPieceNos: [],
        cutListPiece: { label: 'All', value: '' },
        cutListLengths: [],
        cutListLength: { label: 'All', value: '' },
        cutListDescriptions: [],
        cutListDescription: { label: 'All', value: '' },
        search: '',
        changeState: false,
        cutListSummary: {},
        textFileData: '',
        webSocketResponse: {},
        userId: '',
        checkedCuttingList: [],
        userList: [],
        column: '',
        order: '',
        printLoading: false,
        spoolPdfUrl: null,
        evolveId: '',
        activeFacilitiesList: [],
        selectedFacility: { value: null, label: "" },
        isFilterByAll: { partNo: false, size: false, pieceLength: false, description: false, spoolId: false },
        isCompletedCuts: true,
        currentSelectedPackage: {value:'', label: '', labelName: '', type: ''},
        activeCutStation: {value: null, label:''},
        cutIds: [],
        heatNumber: '',
        nestChecked: false,
        cutId: null,
        materialList: [],
        timelogId: null,
        currentTab: "",
        apiFailed: false,
    },
}

const namespacers = {
    listSpools: createNamespacer("CUTTING_SPOOLS_LIST"),
    spoolDetails: createNamespacer("SPOOL_DETAILS"),
}

const listReducer = createReducer(initialState.list, {
    "SET_SHOW_GENERATE_QRCODE": (state, action) => {
        return {
            ...state,
            showGenerateQrCode: action.payload.value,
            cutListId: action.payload.id,
            // partNo: action.payload.number,
        }
    },
    "SET_CHANGE_STATE": (state, action) => {
        return {
            ...state,
            changeState: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_SPOOLS_SEARCH')]: (state, action) => {
        return {
            ...state,
            search: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_EVOLVE_ID')]: (state, action) => {
        return {
            ...state,
            evolveId: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_COLUMN_ORDER')]: (state, action) => {
        return {
            ...state,
            column: action.payload.column,
            order: action.payload.order,
        }
    },
    [namespacers.listSpools('SET_FILE_DATA')]: (state, action) => {
        return {
            ...state,
            textFileData: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_CURRENT_PACKAGE')]: (state, action) => {
        return {
            ...state,
            currentSelectedPackage: action.payload.value,
        }
    },
    [namespacers.listSpools('FILTER_BY_ALL')]: (state, action) => {
        return {
            ...state,
            isFilterByAll: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_FAB_FACILITIES_LIST')]: (state, action) => {
        return {
            ...state,
            activeFacilitiesList: action.payload.facilities,
        }
    },
    [namespacers.listSpools('SET_SELECTED_FACILITY')]: (state, action) => {
        return {
            ...state,
            selectedFacility: action.payload.facility,
        }
    },
    [namespacers.listSpools('SET_ISCOMPLETEDCUTS')]: (state, action) => {
        return {
            ...state,
            isCompletedCuts: action.payload.value,
        }
    },
    [namespacers.listSpools('SET_ACTIVE_CUT_STATION')]: (state, action) => {
        return {
            ...state,
            activeCutStation: action.payload.value,
        }
    },
    [namespacers.listSpools("CLEAR_DATA")]: (state, action) => {
        let lastPackage = { label: state.package.label, value: state.package.value, type: state.package.type }
        let facilitiesList = state.activeFacilitiesList
        let facilitySelected = state.selectedFacility
        let iscompletedCutsScreen = state.isCompletedCuts
        let currentpack = state.currentSelectedPackage
        let activeCS= state.activeCutStation
        let prevPackages = state.packageList 
        let defaultPackList = state.defaultPackages
        return {
            ...initialState.list,
            package: lastPackage,
            activeFacilitiesList: facilitiesList,
            selectedFacility: facilitySelected,
            isCompletedCuts: iscompletedCutsScreen,
            currentSelectedPackage: currentpack,
            activeCutStation: activeCS,
            packageList: prevPackages,
            defaultPackages: defaultPackList,
            materialList: state.materialList,
            timelogId: state.timelogId,
            currentTab: state.currentTab,
        }
    },
    [namespacers.listSpools("CLEAR_PACKAGE_DATA")]: (state, action) => {
        let facilitiesList = state.activeFacilitiesList
        let facilitySelected = state.selectedFacility
        let activeCS= state.activeCutStation
        return {
            ...initialState.list,
            activeFacilitiesList: facilitiesList,
            selectedFacility: facilitySelected,
            activeCutStation: activeCS,
            materialList: state.materialList,
            timelogId: state.timelogId,
            currentTab: state.currentTab,
        }
    },
    [namespacers.listSpools("SET_WEBSOCKET_RESPONSE")]: (state, action) => {

        const spoolsArray = state.spools.map((spool) => {
            return {
                ...spool,
                cut_list_summaries: spool.cut_list_summaries.map((cutList) => {
                    if (action.payload.checkedCuttingList.includes(cutList.cutlist_id)) {
                        return {
                            ...cutList,
                            checked: JSON.parse(action.payload.check),
                            user_id: JSON.parse(action.payload.check) ? action.payload.userId : ''
                        }
                    } else {
                        return cutList
                    }
                })
            }
        })

        const userListArrayFromCutList = spoolsArray.map((spool) => {
            return spool.cut_list_summaries.map((cutList) => {
                return cutList.user_id ? cutList.user_id : null
            })
        })

        const userListArray = without(uniq(flattenDeep(userListArrayFromCutList)), null)

        return {
            ...state,
            // webSocketResponse: action.payload.value,
            // userId: action.payload.userId,
            // checkedCuttingList: action.payload.checkedCuttingList
            spools: spoolsArray,
            userList: userListArray,
        }
    },
    [namespacers.listSpools("SET_SPOOLS")]: (state, action) => {
        const responseMapping = {
            // spools: 'spools',
            requiredDate: 'required_date',
            noOfSpoolsAssigned: 'spools_assigned',
            noOfSpoolsShipped: 'spools_shipped',
            projectName: 'project_name',
            projectCode: 'project_code',
        };

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map((entry) => {
                const [key, responseKey] = entry;
                if (key === 'requiredDate' || key === 'noOfSpoolsAssigned' || key === 'noOfSpoolsShipped') {
                    return [key, action.payload.value.fabrication[responseKey]]
                } else {
                    return [key, action.payload.value[responseKey]]
                }
            })
        )

        const spoolsArray = action.payload.value.spools.map((spool) => {
            return {
                ...spool,
                cut_list_summaries: spool.cut_list_summaries.map((cutList) => {
                    return {
                        ...cutList,
                        checked: cutList.user_id ? true : false
                    }
                })
            }
        })

        // const userListArrayFromCutList = action.payload.value.spools.map((spool) => {
        //     return spool.cut_list_summaries.map((cutList) => {
        //         return cutList.user_id
        //     })
        // })

        // const userListArray = without(uniq(flattenDeep(userListArrayFromCutList)), null)


        return {
            ...state,
            ...loadedFields,
            pageCount: action.payload.pages,
            userList: action.payload.userList,
            spools: spoolsArray,
            package: {
                ...state.package,
                haveRevisionLabels: action.payload.value.fabrication.revision_labels
            }
        }
    },
    [namespacers.listSpools("SET_DEFAULT_HEAT_NUMBERS")]: (state, action) => {
        return {
            ...state,
            cutIds: action.payload.cutIds,
            heatNumber: action.payload.heatNumber,
            nestChecked: action.payload.nestChecked
        }
    },

    [namespacers.listSpools("SET_HEAT_NUMBERS_CUTLIST")]: (state, action) => {

        let heatNumbers = {}

        heatNumbers = { ...state.cutListSummary }
        heatNumbers[action.payload.cutListId] = {
            ...heatNumbers[action.payload.cutListId],
            'heat_number_attributes': {
                'number': action.payload.value,
                'done_by_id': action.payload.userId,
            } ,
        }

        return {
            ...state,
            cutListSummary: { ...heatNumbers },
            cutId: action.payload.cutListId,
        }

    },

    [namespacers.listSpools("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },

    [namespacers.listSpools("SET_SPOOL_PDF_URL")]: (state, action) => {
        return {
            ...state,
            spoolPdfUrl: action.payload.value,
        }
    },

    [namespacers.listSpools("SET_SPOOL_COMPONENTS")]: (state, action) => {
        return {
            ...state,
            spoolComponents: action.payload.value,
        }
    },

    [namespacers.listSpools("CLEAR_SPOOL_COMPONENTS")]: (state, action) => {
        return {
            ...state,
            spoolComponents: [
                ...initialState.list.spoolComponents
            ],
        }
    },

    [namespacers.listSpools("SET_PACKAGE")]: (state, action) => {

        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            package: {
                label: action.payload.value.label,
                value: action.payload.value.value,
                type: action.payload.value.type,
                fabricationId: action.payload.value.fabricationId,
            }
        }


    },

    [namespacers.listSpools("SET_FILTER_DATA")]: (state, action) => {
        return {
            ...state,
            cutListSizes: [
                { label: 'All', value: '' },
                ...action.payload.cutlistSizes,
            ],
            cutListPieceNos: [
                { label: 'All', value: '' },
                ...action.payload.cutlistPieces,
            ],
            cutListLengths: [
                { label: 'All', value: '' },
                ...action.payload.cutlistLengths,
            ],
            cutListDescriptions: [
                { label: 'All', value: '' },
                ...action.payload.cutlistDescriptions,
            ]
        }
    },

    [namespacers.listSpools("SET_SIZE_FILTER")]: (state, action) => {

        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            cutListSize: {
                label: action.payload.value.label,
                value: action.payload.value.value,
            }
        }
    },

    [namespacers.listSpools("SET_PIECE_FILTER")]: (state, action) => {

        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            cutListPiece: {
                label: action.payload.value.label,
                value: action.payload.value.value,
            }
        }
    },

    [namespacers.listSpools("SET_LENGTH_FILTER")]: (state, action) => {

        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            cutListLength: {
                label: action.payload.value.label,
                value: action.payload.value.value,
            }
        }
    },

    [namespacers.listSpools("SET_DESCRIPTION_FILTER")]: (state, action) => {

        if (!action.payload.value) {
            return {
                ...initialState.list,
            }
        }

        return {
            ...state,
            cutListDescription: {
                label: action.payload.value.label,
                value: action.payload.value.value,
            }
        }
    },

    [namespacers.listSpools("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.spoolDetails("UPDATE_SPOOLS")]: (state, action) => {
        const newSpools = state.spools.map(spool => {
            if (spool.id === action.payload.value) {
                const newCutList = spool.cut_list_summaries.filter(cutList => cutList.part_no !== action.payload.partNo)
                spool.cut_list_summaries = newCutList;
                return spool
            }
            return spool
        })
        return {
            ...state,
            spools: [
                ...newSpools
            ]
        }
    },
    [namespacers.spoolDetails("SET_SPOOLS_DETAILS")]: (state, action) => {
        return {
            ...state,
            spoolDetails: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_DEFAULT_PACKAGES")]: (state, action) => {
        return {
            ...state,
            defaultPackages: action.payload.packages,
            package: action.payload.defaultPackage,
        }
    },
    [namespacers.listSpools("SAVE_PACKAGE_LIST")]: (state, action) => {
        return {
            ...state,
            packageList: action.payload.packages,
        }
    },
    "SET_SHOW_SPOOL_DETAILS": (state, action) => {
        if (action.payload.value) {
            document.body.classList.add("conditional-className")
        } else {
            document.body.classList.remove("conditional-className")
        }
        return {
            ...state,
            showSpoolDetails: action.payload.value,
        }
    },
    "SET_PRINT_LOADING": (state, action) => {
        return {
            ...state,
            printLoading: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_MATERIALS_LIST")]: (state, action) => {
        return {
            ...state,
            materialList: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_CLEAR_PACKAGE")]: (state, action) => {
        return {
            ...state,
            package: { label: '', value: '', type: '', fabricationId: null },
        }
    },
    [namespacers.listSpools("SET_TIME_LOG_ID")]: (state, action) => {
        return {
            ...state,
            timelogId: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_CURRENT_TAB")]: (state, action) => {
        return {
            ...state,
            currentTab: action.payload.value,
        }
    },
    [namespacers.listSpools("SET_API_FAILED")]: (state, action) => {
        return {
            ...state,
            apiFailed: action.payload.value,
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
})

export default reducer;